/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * Primarily handles E.164 format (+1XXXXXXXXXX) and US phone numbers
 * @param phone - Phone number string in various formats
 * @returns Formatted phone number in (XXX) XXX-XXXX format, or original input if invalid
 */
export const formatPhoneNumber = ( phone: string | null | undefined ): string => {
	if ( !phone ) {
		return '—'
	}

	// Remove all non-digit characters
	const cleaned = phone.replace( /\D/g, '' )

	// Match US phone number with optional country code (1)
	const regex = /^1?(\d{3})(\d{3})(\d{4})$/
	const match = regex.exec( cleaned )

	if ( match ) {
		return `(${match[ 1 ]}) ${match[ 2 ]}-${match[ 3 ]}`
	}

	// Return original if format doesn't match
	return phone
}
